import Icon from '@ant-design/icons';
import { EditOutlined } from '@ant-design/icons';
import '../style.css';

export const checkStatus = (status) => {
	if (status === 100) return <Icon className="disscount-icon" component={EditOutlined} />;
	return null
};
